import React from 'react'

const Alerta = ({message, type}) => {
    return ( 
        <div className={`alerta ${type}`}>
            {message}
        </div>
    );
}
 
export default Alerta;